import type { DealUpdatePayload } from "./dealUpdateToast";

export function shouldShowDealUpdateNotification(
  data: unknown,
  displayName: string,
  showAllNotifications: boolean,
): boolean {
  if (showAllNotifications) {
    return true;
  }

  const name = displayName.trim();
  if (!name) {
    return false;
  }

  const deal = data as DealUpdatePayload;

  return deal.deal_lead?.name === name || deal.deal_support?.name === name;
}
